/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { Formik } from 'formik';
import * as Yup from 'yup';
import Api from '../../utils/apiCall';
import ReCAPTCHA from 'react-google-recaptcha';

const baseStyle = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '20px',
  borderWidth: 2,
  borderRadius: 2,
  borderColor: '#eeeeee',
  borderStyle: 'dashed',
  backgroundColor: '#fafafa',
  color: '#bdbdbd',
  outline: 'none',
  transition: 'border .24s ease-in-out',
};

const ContactUsForm = (csrfToken) => {
  const [confirmed, setConfirmed] = useState(false);
  const [contact, setContact] = useState();
  const recaptchaRef = React.useRef(null)
  const [error, setError] = useState(null);
  const offerValidationSchema = Yup.object({
    firstName: Yup.string()
      .required('Please provide a first name'),
    lastName: Yup.string()
      .required('Please provide a last name'),
    email: Yup.string().trim()
      .required('Please provide an email')
      .email('Invalid email format'),
    categories: Yup.string()
      .required('Please select the category'),
    message: Yup.string()
      .required('Please enter the message')
      .max(500, 'Maximum 500 characters'),
  });

  const csrf = csrfToken.csrfToken;
  const initialValues = {
    firstName: '',
    lastName: '',
    email: '',
    categories: '',
    message: '',
  };

  const handleKeyDown = (event) => {
    if (event.keyCode === 13) {
      event.preventDefault();
    }
  }
  const handleSubmit = async (values) => {
    setContact(values);
    const token = await recaptchaRef.current?.getValue();
    recaptchaRef.current.reset();
    const result = await fetch('/api/contact', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'CSRF-Token': csrf
      },
      body: JSON.stringify({ contact: values, token: token }),
    });
    if (result.ok)
      setConfirmed(true);
    else
      setError("Please verify that you are not a robot");
    
    window.scrollTo(0, 0);
  }

  const isFormFilled = (values) => {
    if (values.firstName !== ''
      && values.lastName !== ''
      && values.email !== ''
      && values.category !== ''
      && values.message !== '')
      return true;
    return false;
  };

  const form = (
    <Formik
      validationSchema={offerValidationSchema}
      initialValues={initialValues}
      onSubmit={handleSubmit}
    >
      {({
        errors,
        touched,
        isSubmitting,
        values,
        handleChange,
        handleSubmit,
      }) => (
        <Form
          noValidate
          onSubmit={handleSubmit}
          className="g-form text-left airy"
        >
          <Form.Group controlId="firstName">
            <Form.Label>First Name </Form.Label>
            <Form.Control
              type="text"
              value={values.firstName}
              placeholder="First Name"
              onChange={handleChange}
              isValid={touched.firstName && !errors.firstName}
              isInvalid={touched.firstName && errors.firstName}
            />
            <Form.Control.Feedback type="invalid">
              {errors.firstName}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group controlId="lastName">
            <Form.Label>Last Name </Form.Label>
            <Form.Control
              type="text"
              placeholder="Last Name"
              value={values.lastName}
              onChange={handleChange}
              isValid={touched.lastName && !errors.lastName}
              isInvalid={touched.lastName && errors.lastName}
            />
            <Form.Control.Feedback type="invalid">
              {errors.lastName}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group controlId="email">
            <Form.Label>Email Address </Form.Label>
            <Form.Control
              type="text"
              placeholder="Email"
              value={values.email}
              onChange={handleChange}
              isValid={touched.email && !errors.email}
              isInvalid={touched.email && errors.email}
            />
            <Form.Control.Feedback type="invalid">
              {errors.email}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group controlId="categories" className="add-mb">
            <Form.Label>Categories </Form.Label>
            <Form.Control
              as="select"
              required
              onChange={handleChange}
              isValid={touched.categories && !errors.categories}
              isInvalid={touched.categories && errors.categories}
            >
              <option>Select a category</option>
              <option>Investing</option>
              <option>Raising Capital</option>
              <option>Complaint</option>
              <option>Payment</option>
              <option>Other</option>
            </Form.Control>
            <Form.Control.Feedback type="invalid">
              {errors.categories}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group controlId="message">
            <Form.Label>Message</Form.Label>
            <Form.Control
              required
              style={{ height: 160 }}
              as="textarea"
              rows={6}
              cols={40}
              onChange={handleChange}
              isValid={touched.message && !errors.message}
              isInvalid={touched.message && errors.message}
            />
            <Form.Control.Feedback type="invalid">
              {errors.message}
            </Form.Control.Feedback>
          </Form.Group>
          <input type="hidden" name="csrfmiddlewaretoken" value={csrfToken} />

          {error && <p className="text-danger">{error}</p>}
          <ReCAPTCHA
            size="small"
            sitekey={process.env.recaptcha_site_key}
            ref={recaptchaRef}
            onChange={() => setError(null)}
          />

          <br />
          <Button
            variant="outline-primary"
            size="lg"
            disabled={!isFormFilled(values) || isSubmitting}
            type="submit"
          >
            Send Message
          </Button>
        </Form>
      )}
    </Formik>
  );

  const thanks = (
    <div className="lead">
      <p>Thank you for getting in touch!  </p>
      We appreciate you contacting us.
      Our team will get back in touch with you soon!
    </div>
  );

  return !confirmed ? form : thanks;
};

export default ContactUsForm;
